import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Tooltip } from 'components/ui'
import strings from 'l10n'

const NoBuyTooltipAdornment = () => {
  return (
    <Tooltip title={strings.NO_BUY_TOOLTIP}>
      <span style={{ display: 'inline-flex', color: 'rgba(0, 0, 0, 0.54)', cursor: 'help' }}>
        <InfoOutlinedIcon fontSize="small" />
      </span>
    </Tooltip>
  )
}

export default NoBuyTooltipAdornment
